<div id="validation">
  <hyperkit-typography
    class="emulation"
    variant="body"
    size="md"
    align="left"
    color="body"
  >
    {{ validation() }}
  </hyperkit-typography>

  <div class="row justify-content-center">
    @if (
      validationTypes()?.length > 0 && !validationTypes().includes('manual')
    ) {
      <hyperkit-button
        icon="plus"
        size="small"
        color="tertiary"
        text="Download Validation Package"
        (click)="downloadValidation(pkgView.activePackage()?.title ?? '')"
      ></hyperkit-button>
    }
  </div>
</div>
